import { useParams, Navigate } from 'react-router-dom';

export function SAInvestorRedirect() {
  const { investorId } = useParams<{ investorId: string }>();
  // B1: land on the journey picker (per-product) instead of the identity-level profile, so the agent
  // chooses which journey to work within (setting the journey scope the backend enforces in Stage B).
  return <Navigate to={`/service-agent/investors/${investorId}/journeys`} replace />;
}

export default SAInvestorRedirect;
